import { PARTNER_SPECS } from '../actionTypes';

export const partnerAffiliate = (partner) => ({
  type: PARTNER_SPECS.SET_PARTNER_DATA,
  payload: partner,
});
